import axios from 'axios';
import {
    IAlternateContact,
    ICustomerInfo
} from '../../../../contexts/CartContext/CartContext.types';
import { states } from '../../../../components/forms/inputs/StateDropdown';
import { Config } from '../../../../config';
const IdiGatewayApiUrl = `${Config.url.IDI_URL}/v1/CreateCustomerAndGetCreditReport`;

export interface ICustomerRequest {
    firstName: string;
    lastName: string;
    socialSecurityNumber: string;
    driversLicenseNumber: string;
    driversLicenseState: string;
    dateOfBirth: Date;
    serviceAddress: ICustomerAddress;
    phoneNumber: string;
    emailAddress: string;
    employer: string;
    billingAddressIsSameAsPrimary: boolean;
    billingAddress?: ICustomerAddress;
    billingFirstName?: string;
    billingLastName?: string;
    billingDateOfBirth?: Date;
    alternateContact: IAlternateContact;
}

export interface ICustomerAddress {
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipcode: string;
}

export interface ICreateCustomerAndCreditCheckResponse {
    creditClass: string;
    customerID: number;
}

const stateToAbbreviation = (state: string): string => {
    const abbreviation = states.filter((s) => {
        return s.name === state;
    });
    return abbreviation[0].abbreviation;
};

const CreateCustomerAndGetCreditCheck = (
    customerInfo: ICustomerInfo,
    alternateContact: IAlternateContact,
    socialSecurityNumber: string,
    onSuccess: (response: ICreateCustomerAndCreditCheckResponse) => void,
    onFailure: () => void
) => {
    const customerRequest: ICustomerRequest = {
        firstName: customerInfo.firstName,
        lastName: customerInfo.lastName,
        socialSecurityNumber: socialSecurityNumber,
        driversLicenseNumber: customerInfo.driversLicenseNumber,
        driversLicenseState: stateToAbbreviation(customerInfo.driversLicenseState),
        dateOfBirth: new Date(customerInfo.dob),
        employer: customerInfo.employer,
        serviceAddress: {
            addressLine1: customerInfo.address.addressLine1,
            addressLine2: customerInfo.address.addressLine2,
            city: customerInfo.address.city,
            state: stateToAbbreviation(customerInfo.address.state),
            zipcode: customerInfo.address.zipcode
        },
        phoneNumber: customerInfo.phoneNumber,
        emailAddress: customerInfo.emailAddress,
        billingAddressIsSameAsPrimary: !customerInfo.isDifferentBillingAddress,
        alternateContact: alternateContact
    };

    if (customerInfo.isDifferentBillingAddress) {
        customerRequest.billingAddress = {
            addressLine1: customerInfo.billingAddress!.address.addressLine1,
            addressLine2: customerInfo.billingAddress!.address.addressLine2,
            city: customerInfo.billingAddress!.address.city,
            state: stateToAbbreviation(customerInfo.billingAddress!.address.state),
            zipcode: customerInfo.billingAddress!.address.zipcode
        };

        customerRequest.billingFirstName = customerInfo.billingAddress?.firstName;
        customerRequest.billingLastName = customerInfo.billingAddress?.lastName;
        customerRequest.billingDateOfBirth = customerInfo.billingAddress?.dob
            ? new Date(customerInfo.billingAddress.dob)
            : undefined;
    }

    axios.post(IdiGatewayApiUrl, customerRequest).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export default CreateCustomerAndGetCreditCheck;
